<template>
  <div class="input-row" :class="classes">
    <label class="input-label">{{ getLabel() }}</label>
    <input class="input-text" type="text" v-model="val" />
    <span class="icon error">
      <img src="@/assets/img/icon_sprite_error.png" class="sprite" />
    </span>
    <span class="icon check">
      <img src="@/assets/img/icon_sprite_check.png" class="sprite" />
    </span>
    <slide-up-down :active="hasError" :duration="500">
      <span class="input-error">{{ getError() }}</span>
    </slide-up-down>
  </div>
</template>

<script>
import Config from "@/config.js";
import { EventBus } from "@/main.js";

export default {
  name: "RowInputText",
  props: {
    id: {
      type: String,
      default: "",
      required: true
    },
    value: {
      type: String,
      default: "",
      required: false
    },
    validate: {
      type: Function,
      default: function() {
        this.$kRevoValidator().validate;
      },
      required: true
    }
  },
  created: function() {},
  data: function() {
    return {
      val: this.value //this.config.value
    };
  },
  computed: {
    classes: function() {
      return {
        error: this.isNotEmpty && !this.isValid,
        check: this.isValid
      };
    },
    isNotEmpty: function() {
      return this.val === "" ? false : true;
    },
    isValid: function() {
      return this.validate(this.val) === false ? false : true;
    },
    hasError: function() {
      return this.isNotEmpty && !this.isValid;
    }
  },
  filters: {
    trim: function(mystring) {
      return mystring.trim();
    }
  },
  methods: {
    getLabel: function() {
      return Config[this.id].label;
    },
    getHelp: function() {
      return Config[this.id].help;
    },
    getError: function() {
      return Config[this.id].error;
    }
  },
  watch: {
    val: function() {
      //this.$log.debug("emiting event update:check detected");
      EventBus.$emit("update:value", {
        id: this.id,
        value: this.val,
        check: this.isValid
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$font-size-label: 1.25em;
//@import "@/scss/_variables.scss";   //imported globally

.input-row {
  position: relative;
  display: block;
  box-sizing: border-box;
  margin: 0px;
  padding: 0px 3em 1em 0px;
  font-size: 1em;

  .input-label {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 0.75em;
    line-height: 1.5em;

    padding: 0px 0px 0px 0.2em;
    min-height: 1.5em;
    color: $colorGrayDark;

    text-transform: lowercase;
  }

  .input-text {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 1.25em;
    font-family: $font-family-normal;
    line-height: 1.5em;
    width: 100%;
    min-height: 1.5em;
    color: $colorGrayDarker;
    text-align: left;

    margin: 0px;
    padding: 0em 0.25em 0 0.25em;
    border-radius: 4px; //2px;
    border: 1px solid $colorGray;

    overflow: hidden;
    cursor: pointer;
  }

  .input-error {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 0.75em;
    line-height: 1.5em;
    overflow: hidden;
    padding: 0px 0px 0px 0.25em;
    color: $colorRed;
  }

  .icon {
    position: absolute;
    display: none;
    box-sizing: border-box;
    overflow: hidden;
    font-size: 1em;
    right: 0px;
    top: 1.1em;
    width: 2em;
    height: 2em;

    .sprite {
      position: relative;
      display: block;
      box-sizing: border-box;

      width: 100%;
      height: auto;
      margin: 0px;
      padding: 0px;
    }
  }

  &.error {
    .input-text {
      color: $colorRed;
      border-color: $colorRed;
    }

    .icon.error {
      display: block;
    }
  }

  &.check {
    .icon.check {
      display: block;
    }
  }
}
</style>
